import { useSearch } from '@tanstack/react-router';

/**
 * Typed accessor for the `?view` search param used by Space routes.
 *
 * TanStack Router's generic `useSearch({ strict: false })` returns `unknown`,
 * so the cast is unavoidable. Centralising it here means the cast lives in
 * exactly one place and every consumer gets a typed result without reaching for
 * `useSearch` directly.
 *
 * The cast to a concrete type union is safe: `?view` is always a string when
 * present, and the union captures all valid values produced by this codebase.
 */
export function useViewSearch(): { view?: 'canvas' | 'list' | undefined } {
  return useSearch({ strict: false }) as { view?: 'canvas' | 'list' | undefined };
}
